"use strict";
exports.__esModule = true;
exports.useQueryError = exports.isApiError = exports.getBasePathFactoryV3 = exports.getBasePathFactory = void 0;
var types_1 = require("./types");
var react_1 = require("react");
function isHttpError(error) {
    return !!error && (error === null || error === void 0 ? void 0 : error.status) !== 200;
}
var getBasePathFactory = function (path) { return function (customerId) {
    return "".concat(types_1.ORCHESTRATION_BASE_PATH).concat(customerId ? "/".concat(customerId) : '').concat(path);
}; };
exports.getBasePathFactory = getBasePathFactory;
var getBasePathFactoryV3 = function (path) { return function (customerId) {
    return "".concat(types_1.ORCHESTRATION_BASE_PATH_V3).concat(customerId ? "/".concat(customerId) : '').concat(path);
}; };
exports.getBasePathFactoryV3 = getBasePathFactoryV3;
function isApiError(error) {
    var _a, _b;
    return !!((_b = (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.code);
}
exports.isApiError = isApiError;
function useQueryError(error, _a) {
    var onFlexApiError = _a.onFlexApiError, onHttpError = _a.onHttpError, onAllErrors = _a.onAllErrors;
    return (0, react_1.useEffect)(function () {
        var bail = false;
        if (isApiError(error)) {
            bail = onFlexApiError === null || onFlexApiError === void 0 ? void 0 : onFlexApiError(error);
        }
        else if (isHttpError(error)) {
            bail = onHttpError === null || onHttpError === void 0 ? void 0 : onHttpError(error);
        }
        if (error && !bail) {
            onAllErrors === null || onAllErrors === void 0 ? void 0 : onAllErrors();
        }
    }, [error]);
}
exports.useQueryError = useQueryError;
